/*
 * smono – Vorschlagssuche (portiert von reinh.art, 08/2026)
 *
 * - Holt Vorschlaege ueber Shopifys Predictive Search API, gerendert durch sections/rh-predictive-search.liquid
 *   (Begriff-Vervollstaendigung + Produkte mit Vorschaubild, ohne Preise).
 * - Textvervollstaendigung im Eingabefeld (Ghost-Text): Tab oder Pfeil rechts uebernimmt den Top-Vorschlag.
 * - Tastatursteuerung: Pfeil runter/hoch durch die Treffer, Enter oeffnet, Esc schliesst.
 * - Bindet an jeden Container mit [data-rh-predictive]: Hero-Suchfeld der Startseite,
 *   Suchvorhang des Kopfes (#nt_search_canvas, den Kalles erst beim ersten Oeffnen nachlaedt)
 *   und das Inline-Suchfeld im Kopf (.frm_search_ac, wird zur Laufzeit uebernommen).
 * - Kalles' eigene Sofortsuche ist in templates/search.pp.liquid abgeklemmt (Klassen js_frm_search/
 *   js_iput_search entfernt), sonst wuerden beide gleichzeitig in dasselbe Feld schreiben.
 */
(function () {
  'use strict';

  var SECTION_ID = 'rh-predictive-search';
  var CANVAS_ID = 'nt_search_canvas';
  var DEBOUNCE_MS = 220;
  var MIN_CHARS = 1;

  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  if (root.charAt(root.length - 1) !== '/') root += '/';
  var SUGGEST_URL = root + 'search/suggest';
  var resultCache = new Map();
  var supportsKeyboard = window.matchMedia ? window.matchMedia('(hover: hover) and (pointer: fine)').matches : true;

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function buildUrl(term, unavailable) {
    var params = [
      'q=' + encodeURIComponent(term),
      'resources[type]=query,product',
      'resources[limit]=10',
      'resources[limit_scope]=each',
      'resources[options][unavailable_products]=' + encodeURIComponent(unavailable || 'last'),
      'resources[options][fields]=title,product_type,variants.title,vendor,tag,variants.sku',
      'section_id=' + SECTION_ID
    ];
    return SUGGEST_URL + '?' + params.join('&');
  }

  /* ---------- Begriff-Vervollständigung aus übersetzten Produktdaten ----------
   * Shopifys „queries" sind nicht lokalisiert (deutsche Begriffe auf /en, /fr, …). Deshalb werden die
   * Vorschläge hier aus den Titeln, Herstellern und Produkttypen der aktuellen Sprache gebaut;
   * Shopify-Queries fließen nur in der Hauptsprache zusätzlich ein (Section liefert sonst []). */
  function esc(str) {
    return String(str).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; });
  }
  function completions(term, data) {
    var t = String(term || '').toLowerCase().replace(/\s+/g, ' ').trim();
    if (!t) return [];
    var maxWords = t.split(' ').length + 2;
    var seen = new Map();
    var order = 0;
    function add(cand, weight) {
      var key = cand.toLowerCase();
      if (key.length <= t.length || key.indexOf(t) !== 0) return;
      var e = seen.get(key);
      if (e) e.count += weight; else seen.set(key, { key: key, count: weight, order: order++ });
    }
    function fromText(text, weight, onlyStart) {
      if (!text) return;
      var words = String(text).replace(/[()|,;:!?"\u201e\u201c\u201d\u00ab\u00bb]/g, ' ').split(/\s+/).filter(Boolean);
      for (var i = 0; i < (onlyStart ? 1 : words.length); i++) {
        if (words.slice(i).join(' ').toLowerCase().indexOf(t) !== 0) continue;
        for (var n = 1; n <= maxWords && i + n <= words.length; n++) {
          var cand = words.slice(i, i + n).join(' ').replace(/[\s&\-\/+*]+$/, '');
          if (cand) add(cand, weight);
        }
        break;
      }
    }
    (data.titles || []).forEach(function (x) { fromText(x, 1); });
    (data.vendors || []).forEach(function (x) { fromText(x, 2); });
    (data.types || []).forEach(function (x) { fromText(x, 1); });
    (data.vtitles || []).forEach(function (x) { fromText(x, 1, true); }); // "Hersteller Titel": pax -> pax mini 2
    var ranked = Array.from(seen.values())
      .sort(function (a, b) { return b.count - a.count || a.key.length - b.key.length || a.order - b.order; })
      .map(function (e) { return e.key; });
    var out = [];
    (data.queries || []).forEach(function (q) {
      var k = String(q).toLowerCase().trim();
      if (k.indexOf(t) === 0 && k.length > t.length && out.indexOf(k) < 0) out.push(k);
    });
    ranked.forEach(function (k) { if (out.indexOf(k) < 0) out.push(k); });
    return out.slice(0, 5); // kompakt zeigt CSS davon 3, breit alle 5
  }

  /* ---------- Eine Sucheinheit (Hero-Formular, Suchvorhang) ---------- */
  function PredictiveSearch(container) {
    this.container = container;
    this.form = container.querySelector('[data-frm-search]') || container.querySelector('form');
    this.input = container.querySelector('[data-input-search]') || (this.form && this.form.querySelector('input[name="q"]'));
    if (!this.form || !this.input) return;
    this.results = container.querySelector('[data-results-search]');
    this.title = container.querySelector('[data-title-search]');
    this.viewAll = container.querySelector('[data-viewAll-search]');
    this.skeleton = container.querySelector('[data-skeleton-search]');
    this.select = container.querySelector('[data-cat-search] select');
    this.panel = container.querySelector('[data-rh-ps-panel]');
    this.isCanvas = !!container.closest('#' + CANVAS_ID);
    this.unavailable = (this.form.querySelector('input[name="options[unavailable_products]"]') || {}).value || 'last';
    this.initialResults = this.results ? this.results.innerHTML : '';
    this.initialTitle = this.title ? this.title.textContent : '';
    this.initialViewAll = this.viewAll ? this.viewAll.innerHTML : '';
    this.timer = null;
    this.controller = null;
    this.lastTerm = '';
    this.topQuery = '';
    this.activeIndex = -1;
    this.ghost = null;
    this.bind();
  }

  PredictiveSearch.prototype.bind = function () {
    var self = this;
    this.input.setAttribute('autocomplete', 'off');
    this.input.setAttribute('aria-autocomplete', 'list');
    this.input.setAttribute('spellcheck', 'false');
    if (this.results) this.results.setAttribute('aria-live', 'polite');

    this.input.addEventListener('input', function () { self.onInput(); });
    this.input.addEventListener('focus', function () { if (self.input.value.trim().length >= MIN_CHARS) self.open(); });
    this.input.addEventListener('keydown', function (e) { self.onKeydown(e); });
    this.input.addEventListener('scroll', function () { self.updateGhost(); });
    this.form.addEventListener('submit', function () { self.onSubmit(); });
    if (this.select) this.select.addEventListener('change', function () { self.onInput(true); });

    var keys = this.container.querySelectorAll('[data-listKey] a, [data-listkey] a');
    for (var i = 0; i < keys.length; i++) {
      keys[i].addEventListener('click', function (e) {
        var key = this.getAttribute('data-key');
        if (!key) return;
        e.preventDefault();
        self.input.value = key;
        self.input.focus();
        self.onInput(true);
      });
    }

    if (!this.isCanvas) {
      document.addEventListener('click', function (e) {
        if (!self.container.contains(e.target)) self.close();
      });
    }
    window.addEventListener('resize', function () { self.updateGhost(); self.updateMode(); });
  };

  /* Layout-Modus: Vorhang und schmale Viewports kompakt (3 + 3), breite Panels ab 1024 px dreispaltig (5 + 8) */
  PredictiveSearch.prototype.wideMode = function () {
    return !this.isCanvas && window.matchMedia && window.matchMedia('(min-width: 1024px)').matches;
  };
  PredictiveSearch.prototype.updateMode = function () {
    var block = this.results && this.results.querySelector('[data-rh-ps]');
    if (!block) return;
    var wide = this.wideMode();
    block.classList.toggle('rh-ps--wide', wide);
    block.classList.toggle('rh-ps--compact', !wide);
  };

  PredictiveSearch.prototype.onInput = function (immediate) {
    var self = this;
    var term = this.input.value.trim();
    clearTimeout(this.timer);
    if (term.length < MIN_CHARS) { this.reset(); return; }
    this.timer = setTimeout(function () { self.search(term); }, immediate ? 0 : DEBOUNCE_MS);
  };

  PredictiveSearch.prototype.search = function (term) {
    var self = this;
    if (term === this.lastTerm && this.results && this.results.querySelector('[data-rh-ps]')) { this.open(); return; }
    this.lastTerm = term;
    if (this.controller) this.controller.abort();
    var url = buildUrl(term, this.unavailable);
    if (resultCache.has(url)) { this.render(resultCache.get(url), term); return; }
    this.setLoading(true);
    var controller = window.AbortController ? new AbortController() : null;
    this.controller = controller;
    fetch(url, { signal: controller ? controller.signal : undefined, headers: { 'Cache-Control': 'no-cache' } })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var block = doc.querySelector('[data-rh-ps]');
        var markup = block ? block.outerHTML : '';
        resultCache.set(url, markup);
        if (self.input.value.trim() !== term) return; // inzwischen weitergetippt
        self.render(markup, term);
      })
      .catch(function (err) {
        if (err && err.name === 'AbortError') return;
        self.setLoading(false);
      });
  };

  PredictiveSearch.prototype.render = function (markup, term) {
    this.setLoading(false);
    if (!this.results) return;
    this.results.innerHTML = markup || '';
    this.results.style.display = '';
    var block = this.results.querySelector('[data-rh-ps]');
    this.topQuery = '';
    if (block) { this.buildCompletions(block, term); this.updateMode(); }
    if (this.title) {
      var t = block ? block.getAttribute('data-title') : '';
      this.title.textContent = t || this.initialTitle;
      this.title.style.display = t ? '' : 'none';
    }
    if (this.viewAll && !this.isCanvas) {
      var tpl = block ? block.querySelector('template[data-rh-ps-viewall]') : null;
      if (tpl) {
        this.viewAll.innerHTML = tpl.innerHTML;
        this.viewAll.style.display = '';
      }
    } else if (block) {
      /* Vorhang: Link direkt unter den Treffern statt als Leiste am Boden */
      if (this.viewAll) this.viewAll.style.display = 'none';
      var tpl2 = block.querySelector('template[data-rh-ps-viewall]');
      if (tpl2) {
        var footer = document.createElement('div');
        footer.className = 'rh-ps__footer';
        footer.innerHTML = tpl2.innerHTML;
        block.appendChild(footer);
      }
    }
    this.activeIndex = -1;
    this.updateGhost();
    this.open();
  };

  PredictiveSearch.prototype.buildCompletions = function (block, term) {
    var holder = block.querySelector('[data-rh-ps-queries]');
    var dataEl = block.querySelector('script[data-rh-ps-data]');
    if (!holder) return;
    var data = {};
    try { data = JSON.parse(dataEl ? dataEl.textContent : '{}'); } catch (e) { data = {}; }
    var list = completions(term, data);
    if (!list.length) { holder.parentNode.removeChild(holder); return; }
    var t = String(term).toLowerCase().replace(/\s+/g, ' ').trim();
    var base = block.getAttribute('data-search-link') || '';
    var html = '<h3 class="rh-ps__heading">' + esc(block.getAttribute('data-label-suggestions') || '') + '</h3><ul class="rh-ps__queries" role="listbox">';
    for (var i = 0; i < list.length; i++) {
      var c = list[i];
      html += '<li role="none"><a class="rh-ps__query" role="option" aria-selected="false" data-rh-ps-item data-query="' + esc(c) + '" href="' + esc(base + encodeURIComponent(c)) + '">' +
        '<span class="rh-ps__query-text"><mark>' + esc(c.slice(0, t.length)) + '</mark><span>' + esc(c.slice(t.length)) + '</span></span></a></li>';
    }
    holder.innerHTML = html + '</ul>';
    holder.removeAttribute('hidden');
    var empty = block.querySelector('[data-rh-ps-empty]');
    if (empty) empty.parentNode.removeChild(empty);
    block.setAttribute('data-top-query', list[0]);
    this.topQuery = list[0];
  };

  PredictiveSearch.prototype.reset = function () {
    if (this.controller) this.controller.abort();
    this.lastTerm = '';
    this.topQuery = '';
    this.activeIndex = -1;
    this.setLoading(false);
    if (this.results) {
      this.results.innerHTML = this.initialResults;
      if (!this.initialResults.trim()) this.results.style.display = 'none';
    }
    if (this.title) { this.title.textContent = this.initialTitle; this.title.style.display = this.initialTitle ? '' : 'none'; }
    if (this.viewAll) { this.viewAll.innerHTML = this.initialViewAll; this.viewAll.style.display = this.initialViewAll.trim() ? '' : 'none'; }
    this.updateGhost();
    if (!this.isCanvas) this.close();
  };

  PredictiveSearch.prototype.setLoading = function (on) {
    this.container.classList.toggle('rh-ps-loading', !!on);
    if (this.skeleton) {
      var hasResults = this.results && this.results.querySelector('[data-rh-ps]');
      this.skeleton.classList.toggle('dn', !(on && !hasResults));
    }
  };

  PredictiveSearch.prototype.open = function () {
    if (this.isCanvas) return;
    this.container.classList.add('is--rh-open');
    this.input.setAttribute('aria-expanded', 'true');
  };

  PredictiveSearch.prototype.close = function () {
    if (this.isCanvas) return;
    this.container.classList.remove('is--rh-open');
    this.input.setAttribute('aria-expanded', 'false');
    this.setActive(-1);
  };

  /* ---------- Ghost-Text: Vervollständigung im Eingabefeld ---------- */
  PredictiveSearch.prototype.ensureGhost = function () {
    if (this.ghost) return this.ghost;
    var parent = this.input.parentElement;
    if (!parent) return null;
    if (getComputedStyle(parent).position === 'static') parent.classList.add('rh-ps-has-ghost');
    var ghost = document.createElement('span');
    ghost.className = 'rh-ps-ghost';
    ghost.setAttribute('aria-hidden', 'true');
    ghost.innerHTML = '<span class="rh-ps-ghost__typed"></span><span class="rh-ps-ghost__rest"></span>';
    parent.appendChild(ghost);
    this.ghost = ghost;
    return ghost;
  };

  PredictiveSearch.prototype.ghostCompletion = function () {
    var typed = this.input.value;
    var top = this.topQuery;
    if (!supportsKeyboard || !top || !typed) return '';
    var t = typed.replace(/\s+/g, ' ');
    if (top.length <= t.length) return '';
    if (top.toLowerCase().indexOf(t.toLowerCase()) !== 0) return '';
    if (/\s$/.test(typed)) return '';
    return top.slice(t.length);
  };

  PredictiveSearch.prototype.updateGhost = function () {
    var rest = this.ghostCompletion();
    if (!rest) {
      if (this.ghost) { this.ghost.style.display = 'none'; this.input.removeAttribute('data-rh-ghost'); }
      return;
    }
    var ghost = this.ensureGhost();
    if (!ghost) return;
    var input = this.input;
    var cs = getComputedStyle(input);
    ghost.style.display = '';
    ghost.style.left = input.offsetLeft + 'px';
    ghost.style.top = input.offsetTop + 'px';
    ghost.style.width = input.offsetWidth + 'px';
    ghost.style.height = input.offsetHeight + 'px';
    ghost.style.font = cs.font;
    ghost.style.letterSpacing = cs.letterSpacing;
    ghost.style.textTransform = cs.textTransform;
    ghost.style.textIndent = cs.textIndent;
    ghost.style.textAlign = cs.textAlign;
    ghost.style.lineHeight = cs.lineHeight;
    ghost.style.padding = cs.padding;
    ghost.style.border = cs.borderTopWidth + ' solid transparent';
    ghost.style.borderWidth = cs.borderTopWidth + ' ' + cs.borderRightWidth + ' ' + cs.borderBottomWidth + ' ' + cs.borderLeftWidth;
    ghost.style.boxSizing = cs.boxSizing;
    ghost.style.borderRadius = cs.borderRadius;
    ghost.firstChild.textContent = input.value;
    ghost.lastChild.textContent = rest;
    var fits = ghost.lastChild.getBoundingClientRect().right <= input.getBoundingClientRect().right - 44 && input.scrollLeft === 0;
    if (!fits) { ghost.style.display = 'none'; input.removeAttribute('data-rh-ghost'); return; }
    input.setAttribute('data-rh-ghost', rest);
  };

  PredictiveSearch.prototype.acceptGhost = function () {
    var rest = this.ghostCompletion();
    if (!rest || !this.input.hasAttribute('data-rh-ghost')) return false;
    this.input.value = this.topQuery;
    this.updateGhost();
    this.onInput(true);
    return true;
  };

  /* ---------- Tastatur ---------- */
  PredictiveSearch.prototype.items = function () {
    var list = this.results ? Array.prototype.slice.call(this.results.querySelectorAll('[data-rh-ps-item]')).filter(function (el) { return el.offsetParent !== null; }) : [];
    if (this.viewAll && this.viewAll.style.display !== 'none') {
      list = list.concat(Array.prototype.slice.call(this.viewAll.querySelectorAll('[data-rh-ps-item]')));
    }
    return list;
  };

  PredictiveSearch.prototype.setActive = function (index) {
    var items = this.items();
    for (var i = 0; i < items.length; i++) {
      var on = i === index;
      items[i].classList.toggle('is--active', on);
      items[i].setAttribute('aria-selected', on ? 'true' : 'false');
      if (on && items[i].scrollIntoView) items[i].scrollIntoView({ block: 'nearest' });
    }
    this.activeIndex = index;
  };

  PredictiveSearch.prototype.onKeydown = function (e) {
    var items = this.items();
    switch (e.key) {
      case 'Tab':
        if (!e.shiftKey && this.acceptGhost()) e.preventDefault();
        break;
      case 'ArrowRight':
        if (this.input.selectionEnd === this.input.value.length && this.acceptGhost()) e.preventDefault();
        break;
      case 'ArrowDown':
        if (!items.length) return;
        e.preventDefault();
        this.setActive((this.activeIndex + 1) % items.length);
        break;
      case 'ArrowUp':
        if (!items.length) return;
        e.preventDefault();
        this.setActive((this.activeIndex - 1 + items.length) % items.length);
        break;
      case 'Enter':
        if (this.activeIndex > -1 && items[this.activeIndex]) {
          e.preventDefault();
          var item = items[this.activeIndex];
          var q = item.getAttribute('data-query');
          if (q && item.getAttribute('href') === null) { this.input.value = q; this.onInput(true); }
          else window.location.href = item.href;
        }
        break;
      case 'Escape':
        if (this.activeIndex > -1) { e.preventDefault(); this.setActive(-1); }
        else if (!this.isCanvas) this.close();
        break;
      default:
        break;
    }
  };

  /* Kategorie-Auswahl wie bei Kalles: "product_type:X AND begriff" (search-hidden.liquid wertet das aus) */
  PredictiveSearch.prototype.onSubmit = function () {
    if (!this.select || this.select.value === '*' || this.select.value === '') return;
    var term = this.input.value.trim();
    if (term.indexOf('product_type:') === 0) return;
    this.input.value = 'product_type:' + this.select.value + (term ? ' AND ' + term : '');
  };

  /* ---------- Kalles' Kopf-Suchfeld uebernehmen ----------
   * Das Inline-Formular im Kopf (.frm_search_ac, aktiviert in sections/header_3.liquid) wird hier
   * zur Laufzeit auf die eigenen Haken umgestellt, statt snippets/nt_group_btns.liquid anzufassen.
   * Kalles' Sofortsuche haengt an den Klassen js_frm_search/js_iput_search (delegierte Handler) —
   * ohne die Klassen greift sie nicht mehr und schreibt nicht parallel in dasselbe Feld. */
  function adoptHeaderForm(scope) {
    var wraps = (scope || document).querySelectorAll('.frm_search_ac:not([data-rh-predictive])');
    for (var i = 0; i < wraps.length; i++) {
      var wrap = wraps[i];
      var form = wrap.querySelector('form');
      var input = form && form.querySelector('input[name="q"]');
      if (!form || !input) continue;
      form.classList.remove('js_frm_search');
      input.classList.remove('js_iput_search');
      form.setAttribute('data-frm-search', '');
      input.setAttribute('data-input-search', '');
      var btn = form.querySelector('.js_btn_search');
      if (btn) { btn.classList.remove('js_btn_search'); btn.classList.remove('pe_none'); }
      var dead = wrap.querySelectorAll('.search_header__prs, .search_h_break');
      for (var d = 0; d < dead.length; d++) dead[d].parentNode.removeChild(dead[d]);
      var panel = document.createElement('div');
      panel.className = 'rh-ps-inline__panel';
      panel.setAttribute('data-rh-ps-panel', '');
      panel.innerHTML = '<div data-results-search></div>';
      wrap.appendChild(panel);
      wrap.classList.add('rh-ps-inline');
      wrap.setAttribute('data-rh-predictive', '');
    }
  }

  /* ---------- Initialisierung ---------- */
  function initAll() {
    adoptHeaderForm();
    var containers = document.querySelectorAll('[data-rh-predictive]:not(.is--inted)');
    for (var i = 0; i < containers.length; i++) {
      containers[i].classList.add('is--inted');
      new PredictiveSearch(containers[i]);
    }
  }

  /* Kalles rendert den Suchvorhang erst beim ersten Öffnen (data-rendert4s) – dann neu binden */
  function watchCanvas() {
    var canvas = document.getElementById(CANVAS_ID);
    if (!canvas || !window.MutationObserver) return;
    new MutationObserver(function () { initAll(); }).observe(canvas, { childList: true, subtree: true });
  }

  function boot() {
    initAll();
    watchCanvas();
  }

  window.RHPredictiveSearch = { init: boot, initAll: initAll, Search: PredictiveSearch };

  ready(boot);
})();
